import { jwtDecode } from 'jwt-decode';

export const isAuthenticated = () => {
    const token = localStorage.getItem('token');
    if (!token) return false;

    try {
        // jwtDecode NO valida la firma (eso lo hace el backend); acá solo
        // verificamos que el token sea un JWT bien formado y que no esté vencido.
        const decoded = jwtDecode(token);
        // Si el token trae exp y ya pasó, está vencido. Mientras los tokens no
        // tengan exp (pendiente del fix de JWT), un token bien formado se acepta.
        if (decoded.exp && decoded.exp < Date.now() / 1000) return false;
        return true;
    } catch (error) {
        // Token corrupto / no decodificable.
        return false;
    }
};

export const getUserRole = () => {
    const token = localStorage.getItem('token');
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return decoded.role;
    } catch (error) {
        return null;
    }
};
